var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgChatbotAvatar = function SvgChatbotAvatar(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 42.734,
    height: 40.391,
    viewBox: "0 0 42.734 40.391",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a,.b{fill:#00b9ab;}.a{clip-rule:evenodd;}.c{clip-path:url(#a);}.d{clip-path:url(#b);}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M33.814,8.133q.027-.462.027-.938A13.038,13.038,0,0,0,32.252.724a11.41,11.41,0,0,0-4.379-4.435A12.392,12.392,0,0,0,21.624-5.3a12.392,12.392,0,0,0-6.248,1.59A11.41,11.41,0,0,0,11,.724,13.038,13.038,0,0,0,9.406,7.2,13.038,13.038,0,0,0,11,13.667,11.41,11.41,0,0,0,15.376,18.1a12.392,12.392,0,0,0,6.248,1.59,13.075,13.075,0,0,0,3.852-.555c.04,2.289-1.976,4.63-4.8,8.22q12.449-5.522,13.24-19.319ZM21.624,27.391a22.794,22.794,0,0,1-10.962-2.622,19.461,19.461,0,0,1-7.643-7.225A19.723,19.723,0,0,1,.257,7.2,19.723,19.723,0,0,1,3.019-3.153a19.461,19.461,0,0,1,7.643-7.225A22.794,22.794,0,0,1,21.624-13a22.632,22.632,0,0,1,10.934,2.622A19.713,19.713,0,0,1,40.2-3.153,19.572,19.572,0,0,1,42.991,7.2,19.572,19.572,0,0,1,40.2,17.544a19.713,19.713,0,0,1-7.643,7.225A22.632,22.632,0,0,1,21.624,27.391Z",
    transform: "translate(-0.257 13)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "b"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M-736,1666.542H3054.313V-437H-736Z",
    transform: "translate(736 437)"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.257 13)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "c",
    transform: "translate(0.257 -13)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "d",
    transform: "translate(-2416.142 -1391.422)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M-4.743-18h75.55V55.207H-4.743Z",
    transform: "translate(2404.477 1393.014)"
  }))))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgChatbotAvatar);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/chatbot_avatar.817ea122911bb1891df7c52fc8490e0f.svg";